import React, { useEffect, useState } from 'react';
import '../My-assessment/myAssessment.scss';
import { Table } from 'react-bootstrap';
import { getReport, getOldReport, getOldNextReport, resetLoading } from '../../Redux/ActionCreators/reportAction';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { convertDate, formatAMPM } from '../../utils/miscelleneous';
import { useTranslation } from 'react-i18next';
import moment from 'moment';


export default function Reports() {
    const [activeTab, setActiveTab] = useState('new');
    const [page, setPage] = useState(1);
    const [oldPage, setOldPage] = useState(1);
    const [query, setQuery] = useState('');
    const [sortVal, setSortVal] = useState(2);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { isReportLoading, testReport, totalCount, oldTestReport } = useSelector(state => state.report);

    const testsPerPage = 10;
    const timerRef1 = React.useRef(null);

    const isMobile = window.innerWidth < 767;

    let tenantID = null;
    try {
        const stored = localStorage.getItem("profileDetails");
        if (stored) {
            const parsed = JSON.parse(stored);
            tenantID = parsed?.tenentId || null;
        }
    } catch (err) {
        tenantID = null;
    }

    useEffect(() => {
        if (!tenantID) {
            navigate("/login");
        }
    }, [tenantID, navigate]);

    useEffect(() => {
        if (window.location.search.split('=')[1]) {
            setActiveTab('old');
        }
    }, [])


    useEffect(() => {

        dispatch(resetLoading());
        if (activeTab === 'new') {
            setQuery('');
            setPage(1);
            dispatch(getReport(0, '', 1, testsPerPage, sortVal));
        } else {
            setQuery('');
            setOldPage(1);
            dispatch(getOldReport(tenantID, '', 1, testsPerPage));
        }
    }, [activeTab, dispatch, tenantID, testsPerPage, sortVal]);

    const onTabChange = (e) => {
        setActiveTab(e);

    }

    const searchReport = (val) => {
        clearTimeout(timerRef1.current);
        setQuery(val);
        setPage(1);
        setOldPage(1);
        timerRef1.current = setTimeout(() => delaySearch(val), 800);
    }

    const delaySearch = async (val) => {
        if (activeTab === 'new') {
            await dispatch(getReport(0, val, 1, testsPerPage, sortVal));
        } else {
            dispatch(getOldNextReport(tenantID, val, 1, testsPerPage));
        }
    }


    const openOneReport = (id, type) => {
        navigate('/test-report', { state: { id: id, type: type, myTest: false, path: 'report' } })
    }

    const selectSort = async (val) => {
        setSortVal(val);
        setPage(1);
        // await dispatch(getReport(0, val, 1, testsPerPage, val));
    }

    // Pagination handler
    const paginate = (pageNumber) => {
        if (activeTab === 'new') {
            const totalPages = Math.ceil(totalCount / testsPerPage);
            if (pageNumber < 1 || pageNumber > totalPages) return;
            setPage(pageNumber);
            dispatch(getReport(0, query, pageNumber, testsPerPage, sortVal));
        } else {
            const totalPages = Math.ceil(totalCount / testsPerPage);
            if (pageNumber < 1 || pageNumber > totalPages) return;
            setOldPage(pageNumber);
            dispatch(getOldNextReport(tenantID, query, pageNumber, testsPerPage));
        }
    };

    // Inline Pagination Component based on your example code
    const Pagination = ({ currentPage, totalPages, currentDataLength, total, paginate }) => {
        const getPageNumbers = () => {
            if (totalPages <= 4) {
                return Array.from({ length: totalPages }, (_, i) => i + 1);
            } else if (currentPage <= 3) {
                return [1, 2, 3, "...", totalPages];
            } else if (currentPage >= totalPages - 2) {
                return [1, "...", totalPages - 2, totalPages - 1, totalPages];
            } else {
                return [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
            }
        };

        return (
            <div className="pagination" style={{ padding: isMobile ? '15px 25px' : '' }}>
                <div className="pagination-info">
                    {currentDataLength > 0 ? (
                        <span>
                            Showing <strong>{(currentPage - 1) * testsPerPage + 1}</strong>-
                            <strong>{(currentPage - 1) * testsPerPage + currentDataLength}</strong> of <strong>{total}</strong>
                        </span>
                    ) : (
                        <span>Showing 0-0 of 0</span>
                    )}
                </div>
                <div className="pagination-buttons">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <img src="/images/leftarrow-icon.svg" alt="" />
                    </button>
                    {getPageNumbers().map((pageNum, index) => (
                        <button
                            key={index}
                            onClick={() => (pageNum === "..." ? null : paginate(pageNum))}
                            className={currentPage === pageNum ? "active" : ""}
                            disabled={pageNum === "..."}
                        >
                            {pageNum}
                        </button>
                    ))}
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}>
                        <img src="/images/leftarrow-icon.svg" alt="" style={{ transform: "rotate(180deg)" }} />
                    </button>
                </div>
            </div>
        );
    };

    return (
        <div className='gappeo-my-tests'>
            <div className='d-flex flex-wrap justify-content-between align-items-center' style={{ padding: '24px' }}>
                <h1 className='d-flex justify-content-center' style={{ fontFamily: `"Manrope", sans-serif` }}>
                    {t('Candidate Reports', { ns: 'mytest' })}</h1>
                <div className='report-btns d-flex align-items-center gap-2'>
                    <button className={activeTab === 'new' ? 'active' : ''} onClick={() => onTabChange('new')}>{t('Reports', { ns: 'mytest' })}</button>
                    <button className={activeTab === 'old' ? 'active' : ''} onClick={() => onTabChange('old')}>{t('Old Reports', { ns: 'mytest' })}</button>
                </div>
            </div>
            {
                activeTab === 'new' ?
                    <div className="table-admin">
                        <div className='search-test mt-1 d-flex align-items-center gap-2'>
                            <div className={activeTab === 'new' ? "has-search" : 'has-search mt-3'} style={{ width: '70%' }}  >
                                <span className="form-control-feedback" >
                                    <img src="/images/search.svg" alt='' width={12} />
                                </span>
                                <input type="text" className="form-control" value={query} placeholder={t('Search candidate by Name or Email Address', { ns: 'mytest' })} onChange={(e) => searchReport(e.target.value)} />
                            </div>
                            {activeTab === 'new' ?
                                <div style={{ width: isMobile ? '50%' : '30%', }}>
                                    <select className='form-control' value={sortVal} onChange={(e) => selectSort(e.target.value)}>
                                        <option value={2}>{t('Test Attempt Date', { ns: 'mytest' })}</option>
                                        <option value={1}>{t('Score', { ns: 'mytest' })}</option>
                                    </select>
                                </div> :
                                null
                            }
                        </div>
                        {isReportLoading ?
                            t('Loading..', { ns: 'home' })
                            :
                            testReport && testReport.length > 0 ?
                                <>
                                    {!isMobile ?
                                        <Table responsive className='assessment-table'>
                                            <thead>
                                                <tr>
                                                    <th>{t('Name', { ns: 'mytest' })}</th>
                                                    <th>{t('Email', { ns: 'mytest' })}</th>
                                                    <th>{t('Test', { ns: 'mytest' })}</th>
                                                    <th>{t('Test Attempt Date', { ns: 'mytest' })}</th>
                                                    <th>{t('Pass / Fail', { ns: 'mytest' })}</th>
                                                    <th>{t('Score', { ns: 'mytest' })}</th>
                                                    <th>{t('Status', { ns: 'mytest' })}</th>
                                                    <th>{t('View', { ns: 'mytest' })}</th>
                                                </tr>
                                            </thead>
                                            <tbody className="table-body">
                                                {
                                                    testReport && testReport?.map((el, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td><strong style={{ color: '#000' }}>{el.name}</strong></td>
                                                                <td>{el.emailId}</td>
                                                                <td>{el.testName}</td>
                                                                <td>{el.testAttemptDate ? convertDate(el.testAttemptDate) : ''}<br />
                                                                    {el.testAttemptDate ? formatAMPM(moment.utc(el.testAttemptDate).local().format()) : ''}
                                                                </td>
                                                                <td className='text-center'>{el.passFailStatus === null ? 'NA' : el.passFailStatus}</td>
                                                                <td>{el.status === 3 ? el.score : 'NA'}</td>
                                                                <td>{el.status === 4 ? 'Violated' : el.status === 3 ? 'Completed' : el.status === 2 ? 'In Progress' : 'Invited'}</td>
                                                                <td >{el.status === 3 || el.status === 4 ?
                                                                    <img src='/images/view-icon.svg' alt='' className='cursor-pointer' onClick={() => openOneReport(el.inviteId, 'new')} /> :
                                                                    'NA'
                                                                }</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </Table>
                                        :
                                        <div className='report-list'>
                                            {testReport && testReport?.map((el, index) => {
                                                return (
                                                    <div className='report-item' key={index}>
                                                        <div className='d-flex justify-content-between align-items-center'>
                                                            <div>
                                                                <h4>{el.name}</h4>
                                                                <h5>{el.emailId}</h5>
                                                            </div>
                                                            <p style={{ color: '#525B66' }}>{el.status === 3 ? 'Completed' : el.status === 2 ? 'In Progress' : 'Invited'}</p>
                                                            <div>
                                                                {el.status === 3 ?
                                                                    <img src='images/arrow-down.svg' alt='' className='cursor-pointer' style={{ rotate: '-90deg' }} onClick={() => openOneReport(el.inviteId, 'new')} /> :
                                                                    'NA'
                                                                }
                                                            </div>
                                                        </div>
                                                        <hr style={{ color: '#00DDFF' }} />
                                                        <div className='d-flex justify-content-between align-items-center'>
                                                            <p>Attempt date {el.testAttemptDate ? convertDate(el.testAttemptDate) : ''}{' '}{el.testAttemptDate ? formatAMPM(moment.utc(el.testAttemptDate).local().format()) : ''} | Score: {el.status === 3 ? el.score : 'NA'} | {el.passFailStatus === null ? 'NA' : el.passFailStatus}</p>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            }
                                        </div>
                                    }
                                    <Pagination
                                        currentPage={page}
                                        totalPages={Math.ceil(totalCount / testsPerPage)}
                                        currentDataLength={testReport.length}
                                        total={totalCount}
                                        paginate={paginate}
                                    />
                                </> :
                                <div className='empty-list'>
                                    <img src='/images/magnifier.svg' alt='' />
                                    <div className='mt-2'>
                                        <h3>{t('There is no Test report yet', { ns: 'mytest' })}</h3>
                                    </div>
                                </div>
                        }
                    </div> :
                    <div className="table-admin mt-2">
                        {isReportLoading ?
                            t('Loading..', { ns: 'home' })
                            :
                            oldTestReport && oldTestReport.length > 0 ?
                                <>
                                    <Table responsive>
                                        <thead>
                                            <tr className='table-head'>
                                                <th className='table-header' style={{ borderTopLeftRadius: '8px' }}>{t('Name', { ns: 'mytest' })}</th>
                                                <th className='table-header'>{t('Email', { ns: 'mytest' })}</th>
                                                <th className='table-header'>{t('Test', { ns: 'mytest' })}</th>
                                                <th className='table-header'>{t('Test Attempt date', { ns: 'mytest' })}</th>
                                                <th className='table-header'>{t('Score', { ns: 'mytest' })}</th>
                                                <th className='table-header' style={{ borderTopRightRadius: '8px' }}>{t('View', { ns: 'mytest' })}</th>
                                            </tr>
                                        </thead>
                                        <tbody className="table-body">
                                            {oldTestReport?.map((el, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{el.name}</td>
                                                        <td>{el.emailId}</td>
                                                        <td>{el.testName}</td>
                                                        <td>{el.testAttemptDate ? convertDate(el.testAttemptDate) : ''}<br />
                                                            {el.testAttemptDate ? formatAMPM(moment.utc(el.testAttemptDate).local().format()) : ''}
                                                        </td>
                                                        <td>{el.scores}</td>
                                                        <td ><img src='/images/view-icon.svg' alt='' className='cursor-pointer' onClick={() => openOneReport(el.candidateSendInviteId, 'old')} /></td>
                                                    </tr>
                                                )
                                            })
                                            }
                                        </tbody>
                                    </Table>
                                    <Pagination
                                        currentPage={oldPage}
                                        totalPages={Math.ceil(totalCount / testsPerPage)}
                                        currentDataLength={oldTestReport.length}
                                        total={totalCount}
                                        paginate={paginate}
                                    />
                                </> :
                                <div className='empty-list'>
                                    <img src='/images/magnifier.svg' alt='' />
                                    <div className='mt-2'>
                                        <h3>{t('There is no Test report yet', { ns: 'mytest' })}</h3>
                                    </div>
                                </div>
                        }
                    </div>

            }
        </div>
    )
}
